export default __webpack_public_path__ + "static/media/makka.fe29fb8b.jpg";